module.exports = __webpack_public_path__ + "fonts/nanumgothic-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nanum_Gothic/nanumgothic-regular-webfont.woff
// module id = 3441
// module chunks = 0